jQuery(function ($) {
  var timeslots = {};

  // Location session
  $('.location-search__results').on('click', '.location-search__card', function (event) {
    event.preventDefault();

    // If location has an external planner
    var href = $(this).attr('href');
    if (href) {
      window.location.replace($(this).attr('href'));
    } else {
      var location = JSON.stringify({ "location": { "page-id": $(this).attr('data-page-id') } });
      SetFlowSessionData(location, function () { window.location.href = flowUrls[2] });
    }
  });

  // Checklist session
  $(".checklist__form").change(function () {
    var tasks = {};
    $(".checklist__form input:checked").each(function () {
      var element = $(this);
      if (element.attr('id') == 'checklist-text') { // is is text
        tasks[element.attr('id')] = $('.checklist__textarea').val();
      } else {
        tasks[element.attr('id')] = element.val();
      }
    });
    tasks = JSON.stringify({ "tasks": tasks });
    SetFlowSessionData(tasks);
  });

  //timeslots session
  $(".flow-day__checkbox").change(function () {
    const selectedDate = $('.date-picker__calendar').val();

    $(".flow-day__checkbox:checked").each(function () {
      var element = $(this);
      timeslots = `${selectedDate} - ${element.val()}`;
    });
  });

  $("#privacyCheckbox").change(function (event) {
    event.preventDefault();
    if ($(this).prop("checked")) {
      $('.flow__end button').prop("disabled", false); // Element(s) are now enabled.
    } else {
      $('.flow__end button').prop("disabled", true); // Element(s) are now disabled.
    }

    console.log(timeslots);
    $(".timeslot-field input").val(timeslots);

    if ($.isEmptyObject(timeslots)) {
      $('.gfield.application-type select').val('Offerte aanvraag');
      console.log('Offerte');
    } else {
      $('.gfield.application-type select').val('Afspraak aanvraag');
      console.log('Afspraak');
    }
  });

  $('#flow-submit').click(function (event) {
    event.preventDefault();
    formid = $(this).data('formid');
    $('#gform_' + formid)[0].submit();

    // Disable button to prevent extra submissions
    $('#flow-submit').addClass('button--loading');
    $('#flow-submit').prop("disabled", true);

    // Enable button to allow submission after error
    var checkError = window.setInterval(function () {
      if ($('.gform_submission_error').length > 0) {
        console.log('wow awatch out');
        $('#flow-submit').removeClass('button--loading');
        $('#flow-submit').prop("disabled", false);

        clearInterval(checkError)
      }
    }, 1000);
  });
});



function SetFlowSessionData(newData, callback) {
  data = {
    'action': 'load_ajax_flow_session_handler',
    'session': load_ajax_flow_session_params.session, // that's how we get params from wp_localize_script() function
    'new_data': newData
  };

  console.log('bestaande array' + load_ajax_flow_session_params.session);
  console.log('toevoeging array' + newData);

  $.ajax({
    url: load_ajax_flow_session_params.ajaxurl, // AJAX handler
    data: data,
    type: 'POST',
    success: function (data, xhr) {
      if ($.isFunction(callback)) {
        callback.call();
      }
    },
    error: function (xhr) {
      console.log('nope.....');
    }
  });
}//end LoadLocationsWithAjax()


